import './main.css';
import './grid.css';
import './kanaword.css';
import './images.css';
import './modal.css';
import './fireworks.css';
import './gravity.css';

import { Elm } from './Main.elm';
import * as serviceWorker from './serviceWorker';

function startAudio(e) { if (window.AudioContext = window.AudioContext || window.webkitAudioContext || !1, window.AudioContext) { let o = [], t = new AudioContext, n = {}; function a(n, a) { let r = new XMLHttpRequest; r.open("GET", n, !0), r.responseType = "arraybuffer", r.onerror = function () { e.ports.audioPortFromJS.send({ type: 0, requestId: a, error: "NetworkError" }) }, r.onload = function () { t.decodeAudioData(r.response, function (t) { let r = o.length, s = n.endsWith(".mp3"); o.push({ isMp3: s, buffer: t }), e.ports.audioPortFromJS.send({ type: 1, requestId: a, bufferId: r, durationInSeconds: (t.length - 0) / t.sampleRate }) }, function (o) { e.ports.audioPortFromJS.send({ type: 0, requestId: a, error: o.message }) }) }, r.send() } function r(e, o) { return (e - o) / 1e3 + t.currentTime } function s(e, o, t) { o ? (e.loopStart = t + o.loopStart / 1e3, e.loopEnd = t + o.loopEnd / 1e3, e.loop = !0) : e.loop = !1 } function u(e, o, t, n, a) { let r = (a - e) / (t - e); return Number.isFinite(r) ? r * (n - o) + o : o } function l(e, o) { return e.map(e => { let n = t.createGain(); n.gain.setValueAtTime(e[0].volume, 0), n.gain.linearRampToValueAtTime(e[0].volume, 0); let a = r(o, o); for (let s = 1; s < e.length; s += 1) { let l = e[s - 1], i = r(l.time, o), d = e[s], p = r(d.time, o); if (p > a && a >= i) { let m = u(i, l.volume, p, d.volume, a); n.gain.setValueAtTime(m, 0), n.gain.linearRampToValueAtTime(d.volume, p) } else p > a ? n.gain.linearRampToValueAtTime(d.volume, p) : n.gain.setValueAtTime(d.volume, 0) } return n }) } function i(e) { for (let o = 1; o < e.length; o += 1)e[o - 1].connect(e[o]) } function d(e, o, n, a, u, d, p, m) { let c = e.buffer, f = e.isMp3 ? 0 / t.sampleRate : 0, $ = t.createBufferSource(); if (p) { let b = 10 + p.loopEnd / 1e3 - c.length / c.sampleRate; if (b > 0) { let g = c.getChannelData(0).length + Math.ceil(b * c.sampleRate), A = t.createBuffer(c.numberOfChannels, g, t.sampleRate); for (let T = 0; T < c.numberOfChannels; T += 1)A.copyToChannel(c.getChannelData(T), T); $.buffer = A } else $.buffer = c } else $.buffer = c; $.playbackRate.value = m, s($, p, f); let _ = l(n, d), I = t.createGain(); return I.gain.setValueAtTime(o, 0), i([$, I, ..._, t.destination]), a >= d ? $.start(r(a, d), f + u / 1e3) : $.start(0, (d - a) / 1e3 + f + u / 1e3), { sourceNode: $, gainNode: I, volumeAtGainNodes: _ } } e.ports.audioPortFromJS.send({ type: 2, samplesPerSecond: t.sampleRate }), e.ports.audioPortToJS.subscribe(e => { let r = new Date().getTime(); for (let u = 0; u < e.audio.length; u += 1) { let p = e.audio[u]; switch (p.action) { case "stopSound": { let m = n[p.nodeGroupId]; n[p.nodeGroupId] = null, m.nodes.sourceNode.stop(), m.nodes.sourceNode.disconnect(), m.nodes.gainNode.disconnect(), m.nodes.volumeAtGainNodes.map(e => e.disconnect()); break } case "setVolume": n[p.nodeGroupId].nodes.gainNode.gain.setValueAtTime(p.volume, 0); break; case "setVolumeAt": { let c = n[p.nodeGroupId]; c.nodes.volumeAtGainNodes.map(e => e.disconnect()), c.nodes.gainNode.disconnect(); let f = l(p.volumeAt, r); i([c.nodes.gainNode, ...f, t.destination]), c.nodes.volumeAtGainNodes = f; break } case "setLoopConfig": { let $ = n[p.nodeGroupId], b = o[$.bufferId].isMp3 ? 0 / t.sampleRate : 0; s($.nodes.sourceNode, p.loop, b); break } case "setPlaybackRate": n[p.nodeGroupId].nodes.sourceNode.playbackRate.setValueAtTime(p.playbackRate, 0); break; case "startSound": { let g = d(o[p.bufferId], p.volume, p.volumeTimelines, p.startTime, p.startAt, r, p.loop, p.playbackRate); n[p.nodeGroupId] = { bufferId: p.bufferId, nodes: g } } } } for (let A = 0; A < e.audioCmds.length; A += 1)a(e.audioCmds[A].audioUrl, e.audioCmds[A].requestId) }) } else console.log("Web audio is not supported in your browser.") }

var app = Elm.Main.init({ node: document.getElementById('root') });

startAudio(app);

let highScoresKey = "highScores"

app.ports.highScoresPortToJS.subscribe(function (message) {
    let highScoreRequest = JSON.parse(message);
    let requestType = highScoreRequest.messageType;

    if (requestType === "requestScoreByLevelID" && highScoreRequest.levelID) {
        let levelID = highScoreRequest.levelID;
        let highScores = getHighScores();
        let highScore = highScores[levelID];

        if (highScore) {
            app.ports.highScoresPortFromJS.send(highScores[levelID].toString());
        }
    }

    if (requestType === "saveScoreByLevelID") {
        let highScore = JSON.parse(message);
        let keys = Object.keys(highScore).filter(key => isNaN(key) === false);
        let highScores = getHighScores();

        keys.map(key => {
            if (key > 0 && highScore[key] <= highScores[key]) { return; }

            highScores[key] = highScore[key];
            localStorage.setItem(highScoresKey, JSON.stringify(highScores));
        });
    }
});

app.ports.settingsPortToJS.subscribe(function (message) {
    let settingsRequest = JSON.parse(message);
    let requestType = settingsRequest.messageType;

    if (requestType === "saveSoundEffectsEnabled") {
        localStorage.setItem("soundEffectsEnabled", settingsRequest.soundEffectsEnabled);
    }

    if (requestType === "saveMusicEnabled") {
        localStorage.setItem("musicEnabled", settingsRequest.musicEnabled);
    }

    if (requestType === "saveTextAudioEnabled") {
        localStorage.setItem("textAudioEnabled", settingsRequest.textAudioEnabled);
    }

    if (requestType === "saveHintsEnabled") {
        localStorage.setItem("hintsEnabled", settingsRequest.hintsEnabled);
    }

    if (requestType === "requestSettings") {
        let soundEffectsEnabled = getBoolSetting("soundEffectsEnabled");
        let textAudioEnabled = getBoolSetting("textAudioEnabled");
        let musicEnabled = getBoolSetting("musicEnabled");
        let hintsEnabled = getBoolSetting("hintsEnabled");

        app.ports.settingsPortFromJS.send({ soundEffectsEnabled, textAudioEnabled, musicEnabled, hintsEnabled });
    }
});

app.ports.deviceClassPortToJS.subscribe(function (deviceClass) {
    if (deviceClass) {
        setDeviceClass(deviceClass);
    }
});

function getBoolSetting(key) {
    let stringSetting = localStorage.getItem(key);
    if (stringSetting !== null && stringSetting !== undefined) {
        return stringSetting === "1";
    }

    return stringSetting;
}

function getHighScores() {
    let highScores = localStorage.getItem(highScoresKey);

    if (!highScores) {
        localStorage.setItem(highScoresKey, JSON.stringify({}));

        return {};
    }

    return JSON.parse(highScores);
}

var root = document.querySelector(':root');
function setDeviceClass(deviceClass) {
    root.classList = [deviceClass];
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();